import React from 'react';
import { observer, calculatorState as store } from 'store';
import Button from 'components/UI/Button';
import ImgSection from '../ImgSection';
import DesktopSection from './DesktopSection';
import { useTrans } from 'utils/localisation';

import * as styles from './DesktopSection.module.scss';

function DesktopCalculator({ id, sections, imgSection }) {
  const { toggleModal } = store;
  const t = useTrans(['calculator']);

  const openModal = () => {
    toggleModal(id, true);
  };

  return (
    <>
      {imgSection && <ImgSection {...imgSection} />}
      <div className={styles.wrapper}>
        {sections.map((props, i) => (
          <DesktopSection key={props.name} calculatorID={id} index={i} {...props} />
        ))}
      </div>
      <div>
        <Button onClick={openModal}>{t('getPrice')}</Button>
      </div>
    </>
  );
}

export default observer(DesktopCalculator);
